import { useGetNotifications } from 'api/notifications';

export function useUnreadNotificationsCount(): number {
    const { data } = useGetNotifications();
    return data?.filter((item) => !item.read).length ?? 0;
}
